export default __webpack_public_path__ + "static/media/expressfarm-gray.da1a5de8.webp";